import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  toggle(event) {
    const clickedButton = event.currentTarget
    const clickedItem = clickedButton.closest('[data-accordion-item]')
    const clickedContent = clickedItem.querySelector('[data-accordion-target="content"]')
    const clickedIcon = clickedItem.querySelector('[data-accordion-target="icon"]')

    const isExpanding = clickedContent.classList.contains("hidden")

    // Close all items
    this.contentTargets.forEach(content => content.classList.add("hidden"))
    this.iconTargets.forEach(icon => icon.classList.remove("rotate-180"))

    // If we were expanding the clicked item, open it
    if (isExpanding) {
      clickedContent.classList.remove("hidden")
      clickedIcon.classList.add("rotate-180")
    }
  }
}
